import {useIntl} from 'react-intl';
import toast from 'react-hot-toast';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {FileData, getShareableFileURL} from '../../../app/pages/documents/api';
import {CommonFile} from '../../../app/pages/admin/documents/api';

interface CopyFileLinkProps {
  file: FileData | CommonFile;
}

/**
 * Copie dans le presse-papier le lien partageable vers le document (cf. getShareableFileURL).
 */
const CopyFileLink = ({file}: CopyFileLinkProps): JSX.Element => {
  const intl = useIntl();

  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(window.location.origin + getShareableFileURL(file));
      toast.success(intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.COPY_LINK.SUCCESS'}));
    } catch (e) {
      toast.error(intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.COPY_LINK.FAIL'}));
    }
  };

  return (
    <OverlayTrigger
      overlay={<Tooltip>{intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.COPY_LINK'})}</Tooltip>}
      placement={'top'}
    >
      <button
        type="button"
        className="cursor-pointer btn btn-link p-0 border-0"
        onClick={handleCopy}
        aria-label={intl.formatMessage({id: 'ADMIN.DOCUMENTS.TABLE.COPY_LINK'})}
      >
        <i className="fs-1 fa-solid fa-link"></i>
      </button>
    </OverlayTrigger>
  );
};

export default CopyFileLink;
